'use client'

import stylesButtonBase from '@fukku/button/Base/ButtonBase.module.css'
import styles from '@fukku/button/Inspirational/ButtonInspirational.module.css'
import {
	BUTTON_INSPIRATIONAL_STATE,
	BUTTON_INSPIRATIONAL_VARIANT,
	type InspirationalExtraProps,
	LINK_SIZE,
	linkInspirationalSizeStyles,
	stateStyles,
} from '@fukku/button/Inspirational/constants'
import { cx } from 'classix'
import {
	SiteClientLink,
	type SiteClientLinkProps,
} from 'links/site/client/SiteClientLink'

type ClientInspirationalLinkProps = SiteClientLinkProps &
	InspirationalExtraProps

export function InspirationalClientLink(
	props: ClientInspirationalLinkProps
): React.ReactNode {
	const {
		children,
		state = BUTTON_INSPIRATIONAL_STATE.DEFAULT,
		variant = BUTTON_INSPIRATIONAL_VARIANT.DEFAULT,
		size = LINK_SIZE.M,
		className,
		...rest
	} = props

	return (
		<SiteClientLink
			{...rest}
			className={cx(
				className,
				styles.buttonInspirational,
				styles[variant],
				linkInspirationalSizeStyles[size],
				stateStyles[state],
				stylesButtonBase.button
			)}
		>
			<span className={styles.text}>{children}</span>
		</SiteClientLink>
	)
}
